const ProductGallery = ({ product }) => {

  return (
    <div className="bg-gray-100 rounded-2xl p-8 flex items-center justify-center">

      <img
        src={product.image?.asset?.url}
        alt={product.name}
        className="
          w-full
          max-w-md
          h-auto
          object-contain
        "
      />

    </div>
  );
};

export default ProductGallery;